import React from "react";

function OnlineDetails({ onlineDetails, clickReset, clickView, clickDelete }) {
  console.log("hehe", onlineDetails);
  return (
    <div className="card mt-3 p-3 w-100 shadow-sm" style={{ fontSize: "12px" }}>
      <h6 className="fw-bold" style={{ color: "#d38740" }}>
        Applicant Details
      </h6>
      <p className="mb-1">
        <strong>Name:</strong> {onlineDetails?.firstName}{" "}
        {onlineDetails?.middleName} {onlineDetails?.lastName}
      </p>
      <p className="mb-1">
        <strong>Position Applied:</strong> {onlineDetails?.positionApplied}
      </p>
      <p className="mb-1">
        <strong>Status:</strong> {onlineDetails?.status}
      </p>

      <div className="d-flex justify-content-between mt-3">
        <button
          className="btn text-white flex-grow-1 me-2"
          style={{ backgroundColor: "#d18237" }}
          onClick={() => clickView()}
        >
          View
        </button>
      </div>
    </div>
  );
}

export default OnlineDetails;
